/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IncidentEventDto } from './IncidentEventDto';
import type { UserDto } from './UserDto';

export type CollaborationToolItemLinkedByUserIncidentEventDto = (IncidentEventDto & {
    createdByUser?: UserDto;
    itemKey?: string;
    itemType?: CollaborationToolItemLinkedByUserIncidentEventDto.itemType;
    itemUrl?: string;
} & {
    itemKey: string;
    itemType: CollaborationToolItemLinkedByUserIncidentEventDto.itemType;
});

export namespace CollaborationToolItemLinkedByUserIncidentEventDto {

    export enum itemType {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
